import { SALES_ORDER_WORKFLOW_STATUS_TO_DB, } from '../constants/sales-order-workflow-stage.js';
const WORKFLOW_STATUS_BY_ID = new Map(Object.entries(SALES_ORDER_WORKFLOW_STATUS_TO_DB).map(([key, id]) => [id, key]));
/** The workflow status key of a Nudool status id; null for a status the workflow does not track (Draft). */
export function leafLinkWorkflowStatusKeyForId(salesOrderStatusId) {
    return WORKFLOW_STATUS_BY_ID.get(salesOrderStatusId) ?? null;
}
//# sourceMappingURL=leaflink-workflow-status-key-for-id.js.map